import Validator from '../validator';

export default class NonEmptyStringValidator extends Validator {
  static validate(string) {
    return !!string && string.trim() !== '';
  }
}
